<template>
    <ScheduleFollowupDialog
        ref="scheduleFollowupDialog"
        class="body-semibold"
        :initial-date="initialDate"
        :event-description="inviteDescription"
        :custom-schedule="handleScheduleInDialog" />
    <ChatAgentToolFrame is-actionable :is-complete="action.action_state.submitted">
        <div class="nadia-chat flex flex-col gap-1" data-testid="chat-followup">
            <div class="nadia-chat text-valence-primary-500">
                <template v-if="action.action_state.submitted"> Ok great! See you next {{ formattedDate.weekday }} at {{ formattedDate.time }}. </template>
                <template v-else> Our next meeting </template>
            </div>
            <div class="text-valence-grey-750">
                <template v-if="action.action_state.submitted"> I have sent an invite to your calendar for next {{ formattedDate.weekday }}. </template>
                <template v-else> Does this time look right to you? </template>
            </div>
        </div>
        <ScheduleTrigger
            v-if="!action.action_state.submitted"
            :disabled="loading"
            class="body-semibold"
            :date="formattedDate"
            :scheduled="isScheduled"
            @click="scheduleFollowupDialog.open()" />
        <div v-if="hasError" class="body-small text-red-700">I'm having issues scheduling our meeting. Please try again later.</div>
        <BaseButton v-if="!action.action_state.submitted" :disabled="loading" class="flex justify-center items-center gap-1" theme="primary" @click="handleSchedule">
            <LoadingSpinner v-if="loading" class="h-4" />Schedule
        </BaseButton>
    </ChatAgentToolFrame>
</template>

<script setup>
import BaseButton from "~vue/components/BaseButton.vue";
import ScheduleFollowupDialog from "~vue/components/ScheduleFollowupDialog.vue";
import ScheduleTrigger from "~vue/components/ScheduleTrigger.vue";
import { useDeferredLoading } from "~vue/composables/useDeferredLoading";
import { useScheduleFollowup } from "~vue/composables/useScheduleFollowup.js";
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import { logError } from "~vue/utils/logUtils";
import { ref, useTemplateRef } from "vue";

import ChatAgentToolFrame from "./ChatAgentToolFrame.vue";

const { loading, start: startLoading, stop: stopLoading } = useDeferredLoading();

const props = defineProps({
    action: {
        type: Object,
        required: true,
    },
    lineIdx: { type: Number, required: true },
    messageId: { type: Number, required: true },
});

const { initialDate, formattedDate, scheduleFollowup, isScheduled, inviteDescription } = useScheduleFollowup({
    line: props.action,
    messageId: props.messageId,
    lineIdx: props.lineIdx,
    source: "chat_agent_tool",
});

const hasError = ref(false);
const scheduleFollowupDialog = useTemplateRef("scheduleFollowupDialog");

function handleScheduleInDialog({ recurring, selectedDate }) {
    hasError.value = false;
    return scheduleFollowup({ recurring, selectedDate, sync: true });
}

async function handleSchedule() {
    startLoading();
    hasError.value = false;

    try {
        // bit hacky, but looks into dialog to get the exposed recurring value.
        // this could be improved by moving calendar related state into the composable
        await scheduleFollowup({ recurring: scheduleFollowupDialog.value?.recurring, sync: true });
    } catch (e) {
        logError(e);
        hasError.value = true;
    } finally {
        stopLoading();
    }
}
</script>
